<div class="row calibrate-error-page" *ngIf="showCalibrateError === true;">
    <div class="col-4 text-center message-container">
    </div>
</div>

<ng-container *ngIf="showCalibrateError === false">
    <iframe #iframe title="Calibrate" [src]="url | safeHtml: 'resourceUrl'" class="frame-container" (load)="loaded = true"></iframe
></ng-container>
